import { useEffect, useState } from 'react';
import { debounce } from 'throttle-debounce';
import { Breakpoints } from '../common/enums';

export const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(() => window.innerWidth);

  useEffect(() => {
    const handleResize = debounce(100, () => setWindowWidth(window.innerWidth));
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      handleResize.cancel();
    };
  }, []);

  return windowWidth;
};

export const useBreakpoint = (minWidth: number) => {
  const windowWidth = useWindowWidth();
  return windowWidth >= minWidth;
};

export const useIsSmallMobile = () => !useBreakpoint(Breakpoints.MOBILE_BREAKPOINT);

export const useIsMobile = () => !useBreakpoint(Breakpoints.TABLET_MIN);

export const useIsNarrowMobile = () => !useBreakpoint(Breakpoints.WIDE_MOBILE_MIN);

export const useIsTablet = () => {
  const isTablet = useBreakpoint(Breakpoints.TABLET_MIN);
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP_MIN);

  return isTablet && !isDesktop;
};
